/**
 * @desc 授权令牌
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(eChapterCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/eChapter/accessToken/${eChapterCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
